/**
 * @generated SignedSource<<79b3d6d150b8bffb938034e1e8acaaea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdatePersonInput = {
  avatarUrl?: string | null;
  clientMutationId?: string | null;
  country?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  password?: string | null;
  phoneNumber?: string | null;
};
export type FormPersonAvatar_UpdatePerson_Mutation$variables = {
  input: UpdatePersonInput;
};
export type FormPersonAvatar_UpdatePerson_Mutation$data = {
  readonly updatePerson: {
    readonly person: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"FormPersonAvatar_person">;
    };
  };
};
export type FormPersonAvatar_UpdatePerson_Mutation = {
  response: FormPersonAvatar_UpdatePerson_Mutation$data;
  variables: FormPersonAvatar_UpdatePerson_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FormPersonAvatar_UpdatePerson_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdatePersonPayload",
        "kind": "LinkedField",
        "name": "updatePerson",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PersonNode",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FormPersonAvatar_person"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FormPersonAvatar_UpdatePerson_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdatePersonPayload",
        "kind": "LinkedField",
        "name": "updatePerson",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PersonNode",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avatarUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4951c9ec3a75888e783d49c3a23f862d",
    "id": null,
    "metadata": {},
    "name": "FormPersonAvatar_UpdatePerson_Mutation",
    "operationKind": "mutation",
    "text": "mutation FormPersonAvatar_UpdatePerson_Mutation(\n  $input: UpdatePersonInput!\n) {\n  updatePerson(input: $input) {\n    person {\n      id\n      ...FormPersonAvatar_person\n    }\n  }\n}\n\nfragment FormPersonAvatar_person on PersonNode {\n  id\n  avatarUrl\n  firstName\n  lastName\n}\n"
  }
};
})();

(node as any).hash = "5bcc81823a3edcb56e16b6b3478a0441";

export default node;
